import {get, isUndefined} from 'lodash';

/**
 * Retrieves a configuration value.
 *
 * @param {string} field - The key of the configuration value to retrieve.
 * @param {*} [defaultVal=null] - The default value to return if the configuration value is undefined.
 * @returns {*} The configuration value if it exists; otherwise, the `defaultVal`.
 */
export const getConfig = (field, defaultVal = null) => {
    const val = get(window.envConfig, field);
    return isUndefined(val) ? defaultVal : val;
};